export const DataMutation_ShippingSetAuthorityToLeave_QueryKey = {
  shippingSetAuthorityToLeave: (): string => {
    const queryKey = "data-mutation--shipping-set-authority-to-leave";
    return queryKey;
  },
};
